const skullUrl = new URL('../assets/skull.png', import.meta.url).href

const TIER_COLORS: Record<string, string> = {
    bronze: 'linear-gradient(180deg, #f1c27d 0%, #c9823a 45%, #8f4b1f 100%)',
    silver: 'linear-gradient(180deg, #f7fbff 0%, #cfd7e3 45%, #7e8898 100%)',
    gold: 'linear-gradient(180deg, #fff3a3 0%, #f4c542 45%, #b87808 100%)',
    platinum: 'linear-gradient(180deg, #f4f8ff 0%, #7fe7ff 38%, #4da3ff 68%, #9d7cff 100%)',
}

function getTierColor(tierName: string | null | undefined): string {
    if (!tierName) return 'rgba(255,255,255,0.15)'
    const key = tierName.toLowerCase().split(' ')[0]
    return TIER_COLORS[key] ?? 'rgba(255,255,255,0.15)'
}

type TierIconProps = {
    tierName?: string | null
    size?: number
}

export const TierIcon = ({ tierName, size = 48 }: TierIconProps) => {
    const color = getTierColor(tierName)
    return (
        <div
            style={{
                width: size,
                height: size,
                background: color,
                WebkitMaskImage: `url(${skullUrl})`,
                WebkitMaskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskImage: `url(${skullUrl})`,
                maskSize: 'contain',
                maskRepeat: 'no-repeat',
                maskPosition: 'center',
                flexShrink: 0,
            }}
        />
    )
}
